module.exports = __webpack_public_path__ + "static/img/spring_jianjiePic.92f9bdf5.png";